// import LoginForm from "./Components/Froms/LoginForm/LoginForm";
import WebRoutes from "./Webroutes/WebRoutes";
// import Navbar from "./Components/Navbar/Navbar";
// import Sidebar from "./Components/Sidebar/Sidebar";
// import { useContext } from "react";
// import MainLayout from "./Layout/MainLayout";
// import { TGCRMContext } from "./Context/Context";

function App() {
  return (
    <div className="App">
      <WebRoutes />
    </div>
  );
}

export default App;
